var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "tenantConfirmModal",
      staticClass: "tenant-confirm-modal",
      attrs: {
        modalType: "large-modal",
        modalId: "tenant-confirm-contact-modal",
      },
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("div", { staticClass: "tennat-confirm-modal__text font-bold" }, [
          _c("p", {
            staticClass: "text",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("tenantConfirms." + _vm.regionName + ".part1", [
                  _vm.companyName,
                ])
              ),
            },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "text",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("tenantConfirms." + _vm.regionName + ".part2", [
                  _vm.companyName,
                ])
              ),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue",
            attrs: { type: "button" },
            on: { click: _vm.close },
          },
          [_vm._v(_vm._s(_vm.$t("action.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: { type: "button" },
            on: { click: _vm.confirm },
          },
          [_vm._v(_vm._s(_vm.$t("action.confirm")))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }